import angular from 'angular';

import integrationList from '../settings.integrations/IntegrationList.directive';
import ringostatSettings from '../settings.integrations/ringostat/RingostatSettings.directive';
import userSettings from '../settings/users/UserSettings.directive';
import appealSourcesSettings from './appealSources/AppealSourcesSettings.directive';
import requestsSettings from './requests/RequestsSettings.directive';

(function () {
  'use strict';

  angular.module('settings').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('settings', {
        url: '/settings',
        template: require('../settings/settings.html'),
      })
      .state('settings.customization', {
        url: '/customization',
        template: require('../settings.customization/customization.html'),
        controller: 'settingsCustomizationCtrl',
        controllerAs: 'vm',
      })
      .state('settings.users', {
        url: '/users',
        template: () => `<div ${userSettings.htmlName}></div>`,
      })
      .state('settings.customfields', {
        url: '/custom-fields',
        template: require('../settings.custom.fields/settings.custom.fields.html'),
      })
      .state('settings.stackingplan', {
        url: '/stacking-plan',
        template: require('../settings.stacking.plan/settings.stacking.plan.html'),
        controller: 'settingsStackingPlanCtrl',
        controllerAs: 'vm',
      })
      .state('settings.embed', {
        url: '/embed',
        template: require('../settings.embed/settings.embed.html'),
        controller: 'settingsEmbedCtrl',
        controllerAs: 'vm',
      })
      .state('settings.requests', {
        url: '/requests',
        template: () => `<div ${requestsSettings.htmlName}></div>`,
      })
      .state('settings.appealsources', {
        url: '/appeal-sources',
        template: () => `<div ${appealSourcesSettings.htmlName}></div>`,
      })
      .state('settings.api', {
        url: '/api',
        template: require('../settings.api/settings.api.html'),
        controller: 'settingsApiCtrl',
        controllerAs: 'vm',
      })
      .state('settings.integrations', {
        url: '/integrations',
        template: () => `<div ${integrationList.htmlName}></div>`,
      })
      .state('settings.wepster', {
        url: '/integrations/wepster',
        template: require('../settings.integrations/wepster/settings.wepster.html'),
        controller: 'settingsWepsterCtrl',
        controllerAs: 'vm',
      })
      .state('settings.ringostat', {
        url: '/integrations/ringostat',
        template: () => `<div ${ringostatSettings.htmlName}></div>`,
      });
  }
})();
